import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-my-3.5" }

import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import ToggleRow from '@/components/neue/wizard/ToggleRow.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy } from '@/config/agentWizardSteps'
import { ENTHUSIASM_OPTIONS, FORMALITY_OPTIONS, TONE_OPTIONS } from '@/view/ai/agentVoiceOptions'


export default {
  __name: 'AgentStepVoice',
  setup(__props) {

const wizard = injectWizard()
const copy = key => sectionCopy(key, wizard.data, wizard.ctx)

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(copy('voice.tone'), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          modelValue: _unref(wizard).data.voice.tone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_unref(wizard).data.voice.tone) = $event)),
          options: _unref(TONE_OPTIONS),
          label: "Tone"
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _mergeProps(copy('voice.formality'), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          modelValue: _unref(wizard).data.voice.formality_level,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(wizard).data.voice.formality_level) = $event)),
          options: _unref(FORMALITY_OPTIONS),
          label: "Formality"
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _mergeProps(copy('voice.enthusiasm'), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          modelValue: _unref(wizard).data.voice.enthusiasm_level,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_unref(wizard).data.voice.enthusiasm_level) = $event)),
          options: _unref(ENTHUSIASM_OPTIONS),
          label: "Enthusiasm"
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, {
      title: copy('voice.emoji').title
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ToggleRow, {
            modelValue: _unref(wizard).data.voice.emoji_enabled,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_unref(wizard).data.voice.emoji_enabled) = $event)),
            title: "Use emoji",
            description: copy('voice.emoji').description
          }, null, 8, ["modelValue", "description"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(copy('voice.brand'))), {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_unref(wizard).data.voice.brand_voice_summary) = $event)),
          rows: "3",
          "aria-label": "Describe your brand",
          class: "block w-full rounded-md border border-gray-300 px-2.5 py-2 text-sm leading-5 text-gray-900 shadow-sm"
        }, null, 512), [
          [_vModelText, _unref(wizard).data.voice.brand_voice_summary]
        ])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}